/**
 * RTWO Indexer Engine — Null Protocol Adapter
 */

import type {
  BlockIndexAdapterResult,
  IProtocolAdapter,
  ProtocolAdapterStatus,
} from './protocol-adapter-interface';

export class NullProtocolAdapter implements IProtocolAdapter {
  readonly adapterId = 'null-protocol-adapter';
  readonly adapterName = 'Null Protocol Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): ProtocolAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async indexBlock(_blockNumber: number): Promise<BlockIndexAdapterResult | null> {
    return null;
  }

  async getLatestBlockNumber(): Promise<number | null> {
    return null;
  }
}
